import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import React from 'react';
import { useI18n } from '../../i18n';

import S from './style/InfoButton';

interface InfoButtonProps {
  infoTrigger: () => void;
  btnTextKey: string;
}

const InfoButton: React.FC<InfoButtonProps> = ({ infoTrigger, btnTextKey }) => {
  const i18n = useI18n();

  return (
    <S.InfoButtonContainer data-cy="info-btn">
      <ButtonTertiaryDark
        size="small"
        renderIcon={() => <S.QuestionMarkIcon />}
        onClick={infoTrigger}
        data-cy="info-button"
        data-testid="info-button"
      >
        {i18n(btnTextKey)}
      </ButtonTertiaryDark>
    </S.InfoButtonContainer>
  );
};

export default InfoButton;
